import React from 'react';
import PropTypes from 'prop-types';
import { PillText } from '@web/atoms';
import { useShopifyOfferContext } from '../../offer/shopifyContext';

export const PromoPill = ({ message = 'off your starter box', variant }) => {
  const { formattedAmount, type } = useShopifyOfferContext();
  return type === 'PERCENT_AMOUNT' && formattedAmount ? (
    <PillText text={`${formattedAmount} ${message}`} variant={variant} />
  ) : null;
};

PromoPill.displayName = 'PromoPill';
PromoPill.propTypes = {
  message: PropTypes.string,
  variant: PropTypes.string,
};
